export const STORE_BASE_URL = 'https://osoriorepuestos.com';

export const storeProductUrl = (id) => `${STORE_BASE_URL}/productos/${id}`;
